import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { standardCommand, CommandBase, Command, DeleteCommand } from '../../../core/model/command';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { DeleteCommandHandlerV2 } from '../../../core/service/command/delete-command-handler.v2.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ActivatedRoute } from '@angular/router';
import { ConnectedDocumentManagerComponent } from '../../../common/component/connected-document-manager/connected-document-manager.component';
import { BuildingDocumentService } from '../../service/data/building-document.service';
import { BuildingDocument } from '../../model/building-document';

@Component({
    selector: 'app-building-document-manager',
    templateUrl: '../../../common/component/connected-document-manager/connected-document-manager.component.html',
    providers: [NavigationService, { provide: DeleteCommandHandler, useClass: DeleteCommandHandlerV2 }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuildingDocumentManagerComponent extends ConnectedDocumentManagerComponent<BuildingDocument> {
  constructor(
    activatedRoute: ActivatedRoute,
    dataService: BuildingDocumentService,
    nativeWindow: NativeWindowService,
    cdf: ColumnDefinitionFactory,
    commandHandlerResolver: StandardCommandHandlerResolver,
    dispatcher: CommandDispatcher
  ) {
    super(activatedRoute, dataService, nativeWindow, cdf, commandHandlerResolver, dispatcher);
  }

  protected get objectIdParameterName(): string {
    return 'buildingId';
  }
}
